module.exports = __webpack_public_path__ + "img/question-black.fa0ef716.svg";